// 新增选中元素
export const ADD_CART_SELECTED = "addCartSelected";
export const COMMIT_ADD_CART_SELECTED = "cart/addCartSelected";
// 删除选中列表
export const REMOVE_CART_SELECTED = "removeCartSelected";
export const COMMIT_REMOVE_CART_SELECTED = "cart/removeCartSelected";
// 修改选中列表
export const CHANGE_CART_SELECTED = "changeCartSelected";
export const COMMIT_CHANGE_CART_SELECTED = "cart/changeCartSelected";
